export default {
	/**
	 * Returns the currently logged in user.
	 *
	 * @returns {Promise<object>} The user object
	 */
	async getCurrent () {}
};
